import { PaginatedGlobalAnnouncementsList } from '@rover/rsdk/src/apiClient/latest';
import { getAxiosInstance } from '@rover/rsdk/src/modules/Network/axios';
import type { Snakeify } from '@rover/rsdk/src/modules/Network/object-utilities';
import { camelize } from '@rover/rsdk/src/modules/Network/object-utilities';
import { fullApiUrl } from '@rover/utilities/apiUrl';

import DefaultAPIErrorHandler from './DefaultAPIErrorHandler';

export const GLOBAL_ANNOUNCEMENTS_URL: string = fullApiUrl('announcements/global/');
export const get = async (): Promise<PaginatedGlobalAnnouncementsList> => {
  const ai = getAxiosInstance();

  try {
    const { data } = await ai.get<Snakeify<PaginatedGlobalAnnouncementsList>>(
      GLOBAL_ANNOUNCEMENTS_URL
    );
    return camelize(data, true);
  } catch (e: any) {
    return DefaultAPIErrorHandler(e, 'There was an error while fetching global announcements.');
  }
};
